import { Avatar, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

import { useProfilePicture } from 'hooks/useMyAccount';
import { RootState } from 'redux/store';

interface ProfileAvatarProps {
    /**
     * Size of the avatar
     * @default 32
     */
    size?: number;
    /**
     * Custom styling for the Avatar
     */
    sx?: object;
    /**
     * Whether to show loading skeleton
     * @default true
     */
    showSkeleton?: boolean;
}

const ProfileAvatar = ({ size = 32, sx = {}, showSkeleton = true }: ProfileAvatarProps) => {
    const user = useSelector((state: RootState) => state.user.entity);
    const { data: profilePictureUrl, isLoading } = useProfilePicture();

    // Show skeleton while loading
    if (isLoading && showSkeleton) {
        return <Skeleton variant="circular" width={size} height={size} sx={{ ...sx }} />;
    }

    // Show avatar with image or fallback to initials
    return (
        <Avatar
            src={profilePictureUrl || undefined}
            sx={{
                width: size,
                height: size,
                bgcolor: !profilePictureUrl ? 'primary.main' : 'transparent',
                fontSize: size / 2.5,
                fontWeight: 600,
                ...sx,
            }}
        >
            {!profilePictureUrl && user?.firstname?.[0]}
        </Avatar>
    );
};

export default ProfileAvatar;
